import { render, staticRenderFns } from "./Denied.vue?vue&type=template&id=da03d3f4&scoped=true"
import script from "./Denied.vue?vue&type=script&lang=ts"
export * from "./Denied.vue?vue&type=script&lang=ts"
import style0 from "./Denied.vue?vue&type=style&index=0&id=da03d3f4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da03d3f4",
  null
  
)

export default component.exports